import { render } from "./TracksheetMarkerPassagesPopover.vue?vue&type=template&id=ce0870da&scoped=true&ts=true"
import script from "./TracksheetMarkerPassagesPopover.vue?vue&type=script&lang=ts"
export * from "./TracksheetMarkerPassagesPopover.vue?vue&type=script&lang=ts"

import "./TracksheetMarkerPassagesPopover.vue?vue&type=style&index=0&id=ce0870da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce0870da"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QBadge,QSpace,QBtn,QTable});
